<template>
  <div>
    <validation-observer>
      <div class="col-12 px-3">
        <div class="col-12 d-flex dropdown-box p-4 mt-4">
          <span class="w-100 ">
            <ValidationProvider
              v-slot="{ errors }"
              name="información"
              rules="required"
            >
              <custom-drop-down
                v-model="selectedInformationSource"
                fieldname="name"
                fieldkey="id"
                :options="informationSources"
                placeholder="Seleccione"
                required
                label="Modo por el cual se enteró del programa de Educación Especial:"
                :error="errors[0]"
                :custom-error-msg.sync="errors[0]"
              />
            </ValidationProvider>
          </span>
        </div>
      </div>
      <!--PRIMERA SECCION -->
      <div class="col-12  mt-4">
        <SectionTitle title="Informacion General" :hasline="true" />
        <!--PRIMER ROW-->
        <div class="pl-2 d-flex justify-content-between ">
          <div class="col-4 pt-0">
            <div class="font-weight-bold">
              Año Académico:
            </div>
            <div>2019-2020</div>
          </div>
          <div class="col-4 pt-0">
            <div class="font-weight-bold">
              Número:
            </div>
            <div>0000151709</div>
          </div>
          <div class="col-4 pt-0">
            <div class="font-weight-bold">
              Estatus:
            </div>
            <div>Pre-Registro</div>
          </div>
        </div>
        <!--SEGUNDA ROW-->
        <div class="pl-2 d-flex justify-content-between">
          <div class="col-4">
            <ValidationProvider
              v-slot="{ errors }"
              name="fecha de referido"
              rules="required"
            >
              <custom-date-picker
                v-model="referealDate"
                label="Referido:"
                format="dd/MMM./yyyy"
                required
                :error="errors[0]"
                :custom-error-msg.sync="errors[0]"
              />
            </ValidationProvider>
          </div>
          <div class="col-4">
            <ValidationProvider
              v-slot="{ errors }"
              name="fecha de evaluacion"
              rules="required"
            >
              <custom-date-picker
                v-model="evaluationDate"
                label="Consentimiento Evaluación:"
                format="dd/MMM./yyyy"
                required
                :error="errors[0]"
                :custom-error-msg.sync="errors[0]"
              />
            </ValidationProvider>
          </div>
          <div class="col-4">
            <ValidationProvider
              v-slot="{ errors }"
              name="fecha registro"
              rules="required"
            >
              <custom-date-picker
                v-model="registerDate"
                label="Registro:"
                format="dd/MMM./yyyy"
                required
                :error="errors[0]"
                :custom-error-msg.sync="errors[0]"
              />
            </ValidationProvider>
          </div>
        </div>
      </div>
      <!--SEGUNDA SECCION -->
      <div class="col-12 mt-4">
        <SectionTitle
          title="Información de Ubicación al Momento de Registro"
          :hasline="true"
        />
        <!--PRIMER ROW-->
        <div class="pl-2 d-flex justify-content-between">
          <div class="col-4 pt-0">
            <ValidationProvider
              v-slot="{ errors }"
              name="lugar"
              rules="required"
            >
              <custom-drop-down
                v-model="selectedPlace"
                fieldname="name"
                fieldkey="id"
                :options="places"
                label="Lugar:"
                :error="errors[0]"
                :custom-error-msg.sync="errors[0]"
              />
            </ValidationProvider>
          </div>
          <div class="col-4 pt-0">
            <ValidationProvider
              v-slot="{ errors }"
              name="tipo"
              rules="required"
            >
              <custom-drop-down
                v-model="selectedType"
                fieldname="name"
                fieldkey="id"
                :options="types"
                label="Tipo:"
                :error="errors[0]"
                :custom-error-msg.sync="errors[0]"
              />
            </ValidationProvider>
          </div>
          <div class="col-4 pt-0" />
        </div>

        <!--SEGUNDA ROW-->
        <div class="pl-2 d-flex justify-content-between">
          <div class=" col-4 ">
            <ValidationProvider
              v-slot="{ errors }"
              name="región"
              rules="required"
            >
              <custom-drop-down
                v-model="selectedRegion"
                fieldname="name"
                fieldkey="id"
                :options="regions"
                label="Región:"
                :error="errors[0]"
                :custom-error-msg.sync="errors[0]"
              />
            </ValidationProvider>
          </div>
          <div class="col-4 ">
            <ValidationProvider
              v-slot="{ errors }"
              name="distrito"
              rules="required"
            >
              <custom-drop-down
                v-model="selectedDistrict"
                fieldname="name"
                fieldkey="id"
                :options="districts"
                label="Distrito:"
                :error="errors[0]"
                :custom-error-msg.sync="errors[0]"
              />
            </ValidationProvider>
          </div>
          <div class="col-4 ">
            <ValidationProvider
              v-slot="{ errors }"
              name="escuela"
              rules="required"
            >
              <custom-drop-down
                v-model="selectedSchool"
                fieldname="name"
                fieldkey="id"
                :options="schools"
                label="Escuela:"
                :error="errors[0]"
                :custom-error-msg.sync="errors[0]"
              />
            </ValidationProvider>
          </div>
        </div>
      </div>
    </validation-observer>
  </div>
</template>

<script>
//import TitleBreadCrumb from "@/components/common/page/TitleBreadcrumb.vue";
import CustomDropDown from '@/components/common/CustomDropDown.vue';
import SectionTitle from '@/components/common/page/SectionTitle.vue';
import CustomDatePicker from '@/components/common/CustomDatePicker';
import { ValidationProvider, ValidationObserver } from 'vee-validate';
export default {
  name: 'GeneralTab',
  data() {
    return {
      informationSources: [{ id: 0, name: 'A traves de la web' }],
      places: [{ id: 0, name: 'Centro de Cuido' }],
      types: [{ id: 0, name: 'Centro de Cuido' }],
      regions: [{ id: 0, name: 'Arecibo' }],
      districts: [{ id: 0, name: 'Arecibo' }],
      schools: [{ id: 0, name: 'CE000 - Arecibo I - Centro de Cuido' }],

      selectedInformationSource: null,
      selectedPlace: null,
      selectedType: null,
      selectedRegion: null,
      selectedDistrict: null,
      selectedSchool: null,
      referealDate: null,
      evaluationDate: null,
      registerDate: null,

      page: {
        icon: 'fas fa-user-circle',
        title: 'Registro: General',
        routes: ['Estudiante', 'Registro', 'General'],
      },
    };
  },
  components: {
    CustomDropDown,
    SectionTitle,
    CustomDatePicker,
    ValidationProvider,
    ValidationObserver,
  },
};
</script>
<style scoped>
.dropdown-box {
  background: #f4f6f3 0% 0% no-repeat padding-box;
  border: 1px solid #e2e2e2;
  border-radius: 5px;
  opacity: 1;
}
</style>
